import React, { useMemo } from 'react';
import { faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons';
import { STATUS_REGISTROS, StatusRegistro, CarteiraFundo } from '../../services/registrosService';
import DatePicker from '../../../../../components/DatePicker/DatePicker';
import Button from '../../../../../components/Button/Button';
import Select from '../../../../../components/Select/Select';
import Input from '../../../../../components/input/Input';
import FiltersCard from '../../../../../components/FiltersCard/FiltersCard';

export interface RegistrosFilterState {
    numeroContrato: string;
    carteiras: string;
    dataAquisicao: string;
    status: string;
}

interface RegistrosFiltersProps {
    filters: RegistrosFilterState;
    onFilterChange: (field: keyof RegistrosFilterState, value: string) => void;
    onClearFilters: () => void;
    onSearch: () => void;
    carteiras: CarteiraFundo[];
    loadingCarteiras?: boolean;
    availableStatuses?: StatusRegistro[];
}

const RegistrosFilters: React.FC<RegistrosFiltersProps> = ({
    filters,
    onFilterChange,
    onClearFilters,
    onSearch,
    carteiras,
    loadingCarteiras = false,
    availableStatuses
}) => {
    const carteiraOptions = useMemo(() => {
        return carteiras.map(carteira => ({
            value: carteira.codigo_carteira,
            label: `${carteira.nome_fantasia_fundo}`
        }));
    }, [carteiras]);

    const statusOptions = useMemo(() => {
        const list = availableStatuses && availableStatuses.length > 0 ? availableStatuses : STATUS_REGISTROS;
        return list.map(status => ({
            value: status,
            label: status
        }));
    }, [availableStatuses]);
    const actions = (
        <>
            <Button variant="secondary" icon={faRefresh} onClick={onClearFilters}>Limpar</Button>
            <Button variant="primary" icon={faSearch} onClick={onSearch}>Buscar</Button>
        </>
    );

    return (
        <FiltersCard actions={actions} columns={4}>
            <Select
                label="Carteira"
                value={filters.carteiras}
                onChange={(value) => onFilterChange('carteiras', value)}
                options={carteiraOptions}
                placeholder="Todas as carteiras"
                disabled={loadingCarteiras}
            />
            <DatePicker
                label="Data de Aquisição"
                value={filters.dataAquisicao}
                onChange={(value) => onFilterChange('dataAquisicao', value)}
                placeholder="Selecione a data"
            />
            <Input
                label="Número do Contrato"
                value={filters.numeroContrato}
                onChange={(value) => onFilterChange('numeroContrato', value)}
                placeholder="Digite o número do contrato"
            />
            <Select
                label="Status"
                value={filters.status}
                onChange={(value) => onFilterChange('status', value)}
                options={statusOptions}
                placeholder="Todos os status"
            />
        </FiltersCard>
    );
};

export default RegistrosFilters;
